import * as React from 'react';
import PhoneInputWithCountry from 'react-phone-number-input';
import type { CountryCode } from 'libphonenumber-js';
import 'react-phone-number-input/style.css';
import { cn } from '@/lib/utils';
import { getDefaultCountryFromLocale } from '@/utils/phoneValidation';

export interface PhoneInputProps extends Omit<React.ComponentProps<typeof PhoneInputWithCountry>, 'onChange' | 'value'> {
  value?: string;
  onChange?: (value: string | undefined) => void;
  defaultCountry?: CountryCode;
}

const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ className, onChange, value, defaultCountry, ...props }, ref) => {
    // Use provided defaultCountry or derive from locale
    const resolvedDefaultCountry = defaultCountry ?? getDefaultCountryFromLocale();

    return (
      <PhoneInputWithCountry
        {...props}
        ref={ref as any}
        value={value}
        onChange={onChange}
        defaultCountry={resolvedDefaultCountry}
        international
        countryCallingCodeEditable={false}
        className={cn(
          'flex w-full h-10 rounded-md border border-line bg-surface text-sm',
          'transition-colors focus-within:outline-none focus-within:border-brand-500',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        numberInputProps={{
          className: cn(
            'flex-1 w-full h-full px-3 bg-transparent text-ink',
            'placeholder:text-text-muted',
            'focus:outline-none',
            'disabled:cursor-not-allowed disabled:opacity-50'
          ),
          maxLength: 20,
        }}
        countrySelectProps={{
          className: 'pl-3 pr-1 h-full bg-transparent border-none focus:outline-none',
        }}
      />
    );
  }
);

PhoneInput.displayName = 'PhoneInput';

export { PhoneInput };
